import service from 'service';

export const getRoles = ({ queryKey: [, params] }) => {
  const url = '/acl/role';
  return service.get(url, { params });
};

export const getRoleById = ({ queryKey: [, id] }) => {
  const url = `/acl/role/${id}`;
  return service.get(url);
};

export const addRole = (payload) => {
  const url = '/acl/role';
  return service.post(url, payload);
};

export const editRole = ({ id, ...payload }) => {
  const url = `/acl/role/${id}`;
  return service.put(url, payload);
};

export const deleteRole = (id) => {
  const url = `/acl/role/${id}`;
  return service.delete(url);
};

export const getAllPermissions = () => {
  const url = '/acl/permission';
  return service.get(url);
};

export const getPermissionsById = ({ queryKey: [, id] }) => {
  const url = `/acl/role/${id}/permission`;
  return service.get(url);
};

export const updatePermissions = ({ id, ...payload }) => {
  const url = `/acl/role/${id}/permission`;
  return service.put(url, payload);
};

export default {};
